import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["getAllBrandsClient"] */ "/app/src/api/saleor/services/indexClient.ts");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/no_image.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/clp/CLP.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/common/customLink/CustomLink.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/common/videoCard/VideoCard.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/HeaderEvents/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/navbar/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pdp/PdpLayoutDetails.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/plp/PLP.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/PortableText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/static/StaticAccordianView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/static/StaticGroupedAccordionContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/static/StaticNavbarSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Breadcrumb/Breadcrumb.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/button/style.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel"] */ "/app/src/components/ui/carousel/Carousel.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/imageV2/ImageV2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/layouts/PdpLayout.tsx");
